function getDataset(str: string) {
  const el = document.getElementById(str);
  if (el) {
    return document.getElementById(str).dataset;
  }
  console.error('Config data is not provided');
  return {};
}
const pdfs = getDataset('pdfs');
const clients = getDataset('clients');
const addins = getDataset('addins');
const endpoints = getDataset('endpoints');

const config = {
  paths: {
    pdfs: {
      terms: pdfs.terms,
      privacy: pdfs.privacy,
      serviceLevel: pdfs.servicelevel,
    },
    clients,
    addins,
  },
  endpoints: {
    onlyOffice: endpoints.onlyoffice,
  },
};

export function currencyConversion(price)
{
  // 1 EUR = 1.95583 BGN
  const conversionRateEU = 1.95583;
  const EUR = (price / conversionRateEU).toFixed(2);
  return isNaN(Number(EUR)) ? "0.00" : EUR;
}


export const MOBILE_WIDTH = 880;

export default config;
